import { STORAGE_KEY } from '../data/constants';

// One entry per brief so two briefs on the same booking never share answers.
const keyFor = (briefUuid) => `${STORAGE_KEY}:${briefUuid || 'local'}`;

export const loadAnswers = (briefUuid) => {
  try {
    const raw = localStorage.getItem(keyFor(briefUuid));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const saveAnswers = (briefUuid, doc) => {
  try {
    localStorage.setItem(keyFor(briefUuid), JSON.stringify(doc));
  } catch (e) {
    // quota / private mode — keep the in-memory state, drop the persistence
  }
};

export const clearAnswers = (briefUuid) => {
  try {
    localStorage.removeItem(keyFor(briefUuid));
  } catch (e) {}
};
